// Поиск целого псевдослучайного числа от min до max, max не включается
export function getRandomInt(min, max) {
    const val = Math.floor(Math.random() * (max - min + 1) + min);

    return val > max ? max : val;
}

export function getRandomIntInclusive(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// возвращает рандомный элемент из массива
export function getRandomElement(set) {
    return set[getRandomInt(0, set.length - 1)];
}

export function makeUid() {
    return Date.now().toString(36) + Math.random().toString(36);
}

// a1 и a2 = [x, y]
export function getEquationOfLineFrom2Points(a1, a2) {
    return {
        k: ((a2[1] - a1[1]) / (a2[0] - a1[0])),
        b: (a2[0] * a1[1] - a1[0] * a2[1]) / (a2[0] - a1[0])
    };
}

export default function getRandomElementWithWeight(items, weights) {
    if (items.length !== weights.length || !items.length) return false;

    const cumulativeWeights = [];

    for (let i = 0; i < weights.length; i += 1) {
        cumulativeWeights[i] = weights[i] + (cumulativeWeights[i - 1] || 0);
    }

    const maxCumulativeWeight = cumulativeWeights[cumulativeWeights.length - 1];
    const randomNumber = maxCumulativeWeight * Math.random();

    for (let itemIndex = 0; itemIndex < items.length; itemIndex += 1) {
        if (cumulativeWeights[itemIndex] >= randomNumber) {
            return items[itemIndex];
        }
    }

    return false;
}

export function radToDeg(angleRad) {
    return (angleRad * Math.PI) / 180;
}

// set = [from, to]
export function findIntersection(set1, set2) {
    return (set2[0] >= set1[0] && set2[0] <= set1[1]) || (set2[1] <= set1[1] && set2[1] >= set1[0]);
}

export function getSinusByCosinus(cos) {
    return Math.sqrt(1 - cos ** 2);
}

export function getVectorsScalarProduct(vector1, vector2) {
    return vector1.x * vector2.x + vector1.y * vector2.y;
}

export function getTwoVectorsAngleCos(vector1, vector2) {
    const scalar = getVectorsScalarProduct(vector1, vector2);

    return scalar / (vector1.length * vector2.length);
}

// получить проекцию вектора vector1 на вектор vector2
export function getVectorOnVectorProjection(vector1, vector2) {
    const scalar = getVectorsScalarProduct(vector1, vector2);

    return scalar / vector2.length;
}
